import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import ShowPasswordIcon from "../../images/icons/ShowPasswordIcon.svg";
import { ContentStyle, DataGridListStyle } from "../../Theme";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuid } from "uuid";
import NoRecords from "../../components/NoRecords";
import PendingRxChangeDetails from "./PendingRxChangeDetails";
import { loadingRxChangeAlerts } from "../../Redux/Slice/RxChangeAlertsSlice";
import ErrorOverlay from "../../components/ErrorOverlay";

export default function PendingRxChangeAlerts(props: any) {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [showFlow, setShowFlow] = useState(false);
  const [docId, setDocId] = useState("");
  const [docName, setDocName] = useState("");

  const columns: GridColDef[] = [
    {
      field: "doctorName",
      headerName: "Doctor",
      width: 350,
      cellClassName: "w40",
      headerClassName: "w40",
    },
    {
      field: "prescriptionCount",
      headerName: "No of Prescriptions",
      width: 310,
      cellClassName: "w30",
      headerClassName: "w30",
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "w30",
      headerClassName: "w30",

      renderCell: ({ row }) => {
        return (
          <>
            <Tooltip title="View">
              <IconButton
                color="primary"
                onClick={() => {
                  setShowFlow(true);
                }}
              >
                <img
                  src={ShowPasswordIcon}
                  alt="Show/Hide Password"
                  loading="lazy"
                />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const RxChangeAlertsCountState = useSelector((state: any) => {
    return { ...state.RxChangeAlertsSlice };
  }); //redux data
  const [rowCountState, setRowCountState] = useState(
    RxChangeAlertsCountState?.Pagination?.totalItems || 0
  );

  const dispatch = useDispatch();
  const PendingRxChangeAlertsCount = (nextPage: number) => {
    let paramsData = {
      pageNumber: nextPage,
      pageSize: pageSize,
    };
    dispatch(loadingRxChangeAlerts(paramsData));
  };

  useEffect(() => {
    PendingRxChangeAlertsCount(page);
  }, [page]);

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      RxChangeAlertsCountState?.Pagination?.totalItems !== undefined
        ? RxChangeAlertsCountState?.Pagination?.totalItems
        : prevRowCountState
    );
  }, [RxChangeAlertsCountState?.Pagination?.totalItems, setRowCountState]);

  return (
    <>
      <ContentStyle>
        <Grid container item xs={12} spacing={0} alignItems="top">
          <Grid item xs={12}></Grid>
          <Grid item xs={12} md={6}>
            <Typography
              className="help"
              component="h6"
              color="primary"
              variant="h6"
            >
              Pending Rx Change Alerts
              <HelpGuideTooltip
                content={
                  <>
                    {" "}
                    <Typography component="div" variant="body1">
                      Change Prescription related alerts resulting from data
                      discrepancies
                    </Typography>
                  </>
                }
              />
            </Typography>{" "}
          </Grid>

          {showFlow ? (
            <PendingRxChangeDetails
              docId={docId}
              docName={docName}
              setShowFlow={setShowFlow}
            />
          ) : (
            <Grid item xs={12}>
              <DataGridListStyle>
                <DataGrid
                  rows={RxChangeAlertsCountState?.Items ?? []}
                  headerHeight={36}
                  sortingOrder={["desc", "asc"]}
                  columns={columns}
                  autoHeight
                  rowHeight={40}
                  pageSize={pageSize}
                  disableSelectionOnClick
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                  paginationMode="server"
                  getRowId={() => uuid()}
                  loading={RxChangeAlertsCountState.isLoading}
                  components={{
                    NoRowsOverlay: NoRecords,
                    NoResultsOverlay: NoRecords,
                    ErrorOverlay: ErrorOverlay,
                  }}
                  error={RxChangeAlertsCountState?.error || undefined}
                  rowCount={rowCountState}
                  page={page}
                  rowsPerPageOptions={[pageSize]}
                  onRowClick={({ row }) => {
                    setShowFlow(true);
                    setDocId(row.doctorId);
                    setDocName(row.doctorName);
                  }}
                  onPageChange={(newPage) => {
                    setPage(newPage);
                  }}
                  getRowClassName={({ row }) => {
                    if (!row.onBehalf) {
                      return "PDoctor";
                    }
                    return "";
                  }}
                />
              </DataGridListStyle>
            </Grid>
          )}
        </Grid>{" "}
      </ContentStyle>
    </>
  );
}
